import { Capacitor } from "@capacitor/core";
import { SplashScreen } from "@capacitor/splash-screen";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { applyCompanionChrome, loadCompanionChrome } from "./chrome";
import { formatDiagLine, installDiagnosticSink, installGlobalDiagnostics, persistBrowserDiagnostic } from "@northstar/dispatch-core";
import { ErrorBoundary } from "./ErrorBoundary";
import "@fontsource/roboto/latin-400.css";
import "@fontsource/roboto/latin-700.css";
import "mapbox-gl/dist/mapbox-gl.css";
import "./styles.css";

function releaseNativeSplash() {
  if (!Capacitor.isNativePlatform()) return;
  void SplashScreen.hide().catch(() => undefined);
}

// Before render, and again on a timer. Nothing here waits on the network,
// the update check, or a sync. MainActivity also drops its own overlay.
releaseNativeSplash();
if (Capacitor.isNativePlatform()) window.setTimeout(releaseNativeSplash, 3000);

installGlobalDiagnostics();
installDiagnosticSink((entry) => persistBrowserDiagnostic(formatDiagLine(entry)));
applyCompanionChrome(document.documentElement, loadCompanionChrome(window.localStorage));

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </StrictMode>,
);

if ("serviceWorker" in navigator && import.meta.env.PROD && !Capacitor.isNativePlatform()) {
  window.addEventListener("load", () => {
    void navigator.serviceWorker.register("/sw.js").catch(() => undefined);
  });
}
